import { List } from 'immutable'
import { HttpResult } from 'widgets-for-react'
import { ActualitySearchResult } from '../../actualitySearch/actualitySearchState'
import { CourseSearchResult } from '../../courseSearch/courseSearchState'
import { KnowledgeSearchResult } from '../../knowledgeSearch/knowledgeSearchState'

import { SearchResult } from '../../search/searchState'
import { BlocksState } from '../blocks/blocksState'
import { Page, PageWithBlocks, } from '../cmsPageState'
import { transformSharepointBlockData } from './transformers/blockDataToBlock'
import { PreviewSharepointPageData, transformSharepointPageData} from './transformers/pageDataToPage'
import { HomePageData, SharepointPageData } from './types/pageData'

export const search = async (query: string, page: number): Promise<HttpResult<SearchResult>> => {
  const res = await fetch(`/api/v1/pages/search?${new URLSearchParams({page: page.toString(), query }).toString()}`);

  if (!res.ok) {
    return {
      kind: 'failed',
      status: res.status,
    }
  }

  const searchResult: SearchResult = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: searchResult,
  }
}

export const courseSearch = async (query: string, page: number): Promise<HttpResult<CourseSearchResult>> => {
  const res = await fetch(`/api/v1/pages/search-courses?${new URLSearchParams({page: page.toString(), query }).toString()}`);

  if (!res.ok) {
    return {
      kind: 'failed',
      status: res.status,
    }
  }

  const searchResult: CourseSearchResult = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: searchResult,
  }
}

export const actualitySearch = async (query: string, page: number): Promise<HttpResult<ActualitySearchResult>> => {
  const res = await fetch(`/api/v1/pages/search-actualities?${new URLSearchParams({page: page.toString(), query }).toString()}`);

  if (!res.ok) {
    return {
      kind: 'failed',
      status: res.status,
    }
  }

  const searchResult: ActualitySearchResult = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: searchResult,
  }
}

export const knowledgeSearch = async (query: string, page: number): Promise<HttpResult<KnowledgeSearchResult>> => {
  const res = await fetch(`/api/v1/pages/search-knowledge?${new URLSearchParams({page: page.toString(), query }).toString()}`);

  if (!res.ok) {
    return {
      kind: 'failed',
      status: res.status,
    }
  }

  const searchResult: KnowledgeSearchResult = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: searchResult,
  }
}

export const getPreview = async (slug: string, token: string): Promise<HttpResult<PageWithBlocks>> => {
  const res = await fetch(`/api/v1/sharepoint/preview/${slug.toLowerCase()}?token=${token}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
  }

  const data: PreviewSharepointPageData = await res.json()

  const page = transformSharepointPageData(data)

  const blocks = transformToBlocks(data.Content, page)

  return {
    kind: 'result',
    status: 200,
    value: { ...page, blocks },
  }
}

export const getHomePage = async (): Promise<HttpResult<PageWithBlocks>> => {
  const res = await fetch('/api/v1/pages/homepage')

  if (!res.ok) {
    return {
      kind: 'failed',
      status: res.status,
    }
  }

  const pageData: HomePageData = await res.json()

  const page = transformSharepointPageData(pageData)

  const blocks = transformToBlocks(pageData.Content, page)

  return {
    kind: 'result',
    status: 200,
    value: { ...page, blocks },
  }
}
export const getCmsPage = async (
  slug: string
): Promise<HttpResult<PageWithBlocks>> => {
  const res = await fetch(`/api/v1/pages/all/${slug.toLowerCase()}`)

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const pageData: SharepointPageData = await res.json()

  const page = transformSharepointPageData(pageData)

  const blocks = transformToBlocks(pageData.Content, page)

  return {
    kind: 'result',
    status: 200,
    value: { ...page, blocks },
  }
}

// [Custom content types]: Add an api function to fetch and transform your page here
const not_null = <T>(x: T | null | undefined): x is T => x !== null && x !== undefined

export const transformToBlocks = <P extends Page>(content: string, page: P): BlocksState => {
  const webparts = parseWebparts(content)

  const blocks = List(webparts.map((webpart, i) => transformSharepointBlockData(webpart, i, page)).filter(not_null))
  return blocks
}

const parseWebparts = (canvasContent: string) => {
  try {
    const xmlParser = new DOMParser()
    const webparts: any[] = []
    const webpartsData = xmlParser.parseFromString(canvasContent, 'text/html')
    webpartsData.querySelectorAll('[data-sp-webpartdata]').forEach((e) => {
      const attribute = e.getAttribute('data-sp-webpartdata')
      if (attribute !== null) webparts.push(JSON.parse(attribute))
    })
    return webparts.map((data) => {
      const blocks = data.properties
      const searchablePlainTexts = data.serverProcessedContent?.searchablePlainTexts
      const searchableHtmlStrings = data.serverProcessedContent?.htmlStrings
      if (searchablePlainTexts) {
        for (const [key, value] of Object.entries(searchablePlainTexts)) {
          // Decode the html content for rich text field
          var decodedElement = document.createElement('p')
          decodedElement.innerHTML = value as string
          const decodedText = decodedElement.innerText
          blocks[key] = decodedText
        }
      }
      if (searchableHtmlStrings) {
        for (const [key, value] of Object.entries(searchableHtmlStrings)) {
          blocks[key] = value
        }
      }
      return blocks
    })
  } catch (e) {
    console.error(e)
    return []
  }
}
